import type { Scene } from 'three';

/** Freeze a completed world pose across reflection and depth passes. Camera
 * matrices still update normally. Call end in finally before animating again. */
export class ScenePose {
  private automatic = true;
  private active = false;

  begin(scene: Scene): void {
    if (this.active) throw new Error('Scene pose already open');
    this.automatic = scene.matrixWorldAutoUpdate;
    if (this.automatic) scene.updateMatrixWorld();
    scene.matrixWorldAutoUpdate = false;
    this.active = true;
  }

  end(scene: Scene): void {
    if (!this.active) return;
    scene.matrixWorldAutoUpdate = this.automatic;
    this.active = false;
  }
}
